<template>
    <div>
        <h1>개인정보 제공 동의(한국보건의료정보원-중계전문기관)</h1>
        <h3>1. 개인정보를 제공받는 자</h3>
        한국보건의료정보원(보건의료 마이데이터 서비스 중계전문기관)<br>
        <h3>2. 제공되는 정보</h3>
        회원 가입여부(사용자 번호), 연계항목 목록, 클라이언트ID, 전송요구내역목록, 정보제공자 기관코드, 전송요구일자, 전송요구종료시점<br>
        <h3>3. 제공 목적</h3>
        마이데이터 서비스 가입현황 안내 및 전송요구내역 통합조회 서비스 제공<br>
        <h3>4. 제공받는 자의 보유 및 이용기간</h3>
        한국보건의료정보원의 마이데이터 서비스 가입현황 안내 및 전송요구내역 통합조회 서비스 목적 달성 시까지<br><br>
        정보주체는 위 개인정보의 제3자 제공을 거부할 수 있습니다. 그러나 그 경우 본인의료정보 통합조회 및 데이터 분석 서비스를 이용할 수 없습니다.
    </div>
</template>

<script>
export default {
    name: 'mydataRelayAgency'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/mydata/RelayAgency.vue